import type { ColumnDef } from '@tanstack/react-table';
import { DataTableColumnHeader } from '@/components/DataTable/Columns/DataTableColumnHeader';
import type { HelperOptions } from '@/components/DataTable/types';
import PersonCell from '../Cells/PersonCell';
type Person = {
  id: string;
  avatarUrl?: string;
  name: string;
  email?: string;
  // リンクをプロフィールページ以外にオーバーライドする場合に指定
  linkTo?: string;
};
type NestedKeys<T> = T extends object ? { [K in keyof T]: K extends string ? `${K}` | `${K}.${NestedKeys<T[K]>}` : never }[keyof T] : never;

/** Personを表示するカラム */
export function personColumn<TData>(id: NestedKeys<TData>, helperOptions: HelperOptions & {
  alumni?: boolean;
  openNewTab?: boolean;
}): ColumnDef<TData> {
  const {
    minWidth,
    alumni,
    openNewTab,
    enableHiding = true
  } = helperOptions;
  return {
    accessorKey: id,
    enablePinning: true,
    enableSorting: helperOptions.sortable ?? true,
    enableHiding,
    meta: {
      i18nKey: helperOptions.i18nKey ?? 'person',
      thStyle: {
        minWidth
      }
    },
    header: DataTableColumnHeader,
    cell({
      getValue
    }) {
      const person = getValue();
      return <PersonCell person={person} alumni={alumni} openNewTab={openNewTab} linkTo={person?.linkTo} />;
    }
  } satisfies ColumnDef<TData, Person> as ColumnDef<TData>;
}